module.exports = __webpack_public_path__ + "img/16.eec0a016.jpg";